import { render, staticRenderFns } from "./QnaManager.vue?vue&type=template&id=672ff181&"
import script from "./QnaManager.vue?vue&type=script&lang=js&"
export * from "./QnaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports